import { render, staticRenderFns } from "./enforce-notice.vue?vue&type=template&id=b8a4e21e&scoped=true"
import script from "./enforce-notice.vue?vue&type=script&lang=js"
export * from "./enforce-notice.vue?vue&type=script&lang=js"
import style0 from "./enforce-notice.vue?vue&type=style&index=0&id=b8a4e21e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8a4e21e",
  null
  
)

export default component.exports